/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isregistrationpossiblebesidestimeframe4Inputs */

const en__field_isregistrationpossiblebesidestimeframe4 = /** @type {(inputs: _Field_Isregistrationpossiblebesidestimeframe4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration outside semester possible`)
};

const de__field_isregistrationpossiblebesidestimeframe4 = /** @type {(inputs: _Field_Isregistrationpossiblebesidestimeframe4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung außerhalb des Semester möglich`)
};

/**
* | output |
* | --- |
* | "Registration outside semester possible" |
*
* @param {_Field_Isregistrationpossiblebesidestimeframe4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isregistrationpossiblebesidestimeframe4 = /** @type {((inputs?: _Field_Isregistrationpossiblebesidestimeframe4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isregistrationpossiblebesidestimeframe4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isregistrationpossiblebesidestimeframe4(inputs)
	return de__field_isregistrationpossiblebesidestimeframe4(inputs)
});
export { _field_isregistrationpossiblebesidestimeframe4 as "_field_isRegistrationPossibleBesidesTimeframe" }